<template>
  <div class="">
    <CCard class="auction-manager-card">
      <CCardHeader>
        <div class="auction-manager-card__header">
          <div class="header-container">
            <div class="btn btn-outline-dark btn-lg cursor-pointer">
              <div
                class="handler"
                tabindex="0"
                @click="$refs.fileInput.click()"
              >
                <input
                  ref="fileInput"
                  accept=".csv, text/csv"
                  type="file"
                  autocomplete="off"
                  tabindex="-1"
                  style="display: none"
                  multiple
                  name="csvUpload"
                  @input="fileInputFun"
                />
                <span>Import</span>
              </div>
            </div>
            <div v-if="tableData.length > 0">
              <button
                type="button"
                class="btn btn-primary btn-lg submit d-block"
                @click="sendingData"
              >
                <CSpinner v-if="isSendingData" size="3xl" color="white" class="mr-3" />
                <span>Upload</span>
              </button>
            </div>
          </div>
        </div>
      </CCardHeader>
      <CCardBody color="white" border-color="white">
        <CDataTable
          class="auction-manager__table"
          :items="tableData"
          :fields="fields"
          :loading="loading"
          ref="table"
        >
          <template #rowId="{item}">
            <td :data-row-id="item.id"></td>
          </template>

          <template #car="{item}">
            <td>
              <VCarCard class="auction-manager__car" :car="item.car" />
            </td>
          </template>
          <template #link="{item}">
            <td>
              <a
                :class="{ 'auction-manager__disabled-link': !item.link }"
                :href="item.link"
                target="blank"
              >
                Link
              </a>
            </td>
          </template>
          <template #price="{item}">
            <td class="auction-status">
              <span>price:{{ item.price }}</span>
            </td>
          </template>
          <template #status="{item}">
            <td class="auction-status">
              <CBadge :color="getColor(item.status)">{{ item.status }}</CBadge>
            </td>
          </template>
          <template #comments="{item}">
            <td
              class="comments"
              :class="item.comments && item.comments.length > 0 ? 'has-comments' : ''"
            >
              <a
                @click="openComments(item)"
                class="cursor-pointer"
                v-if="item.comments && item.comments.length > 0"
                >View Comments</a
              >
              <span v-else>No Comment</span>
            </td>
          </template>
          <template #edit-header> </template>
          <template #edit="{item}">
            <td>
              <CDropdown>
                <template #toggler>
                  <CButton class="toggler">
                    <CIcon name="dots" />
                  </CButton>
                </template>
                <CDropdownItem class="btn btn-info" @click="editItem(item)">
                  Edit
                </CDropdownItem>
                <CDropdownItem class="btn btn-info" @click="onDeleteItem(item)">
                  Delete
                </CDropdownItem>
              </CDropdown>
            </td>
          </template>

          <template #username="{item}">
            <td class="username">
              <a :href="getUserLink(item.username)" target="_blank">{{
                item.username
              }}</a>
            </td>
          </template>

          <template #verifiedBy="{item}">
            <td class="auction-verified">
              {{ item.verifiedBy }}
            </td>
          </template>

          <template #featured="{item}">
            <td class="featured-status">
              <!-- <input type="checkbox"
            class=""
              size="lg"
              custom
              :name="item.id"
              :id="item.id"
              :checked="item.featured === 1 ? true : false"
              :disabled="item.status === 'In Progress' ? false: true"
              @change="onChangeCheckBoxInput"
            /> -->
              <CInputCheckbox
                class=""
                size="lg"
                custom
                :name="item.id"
                :id="item.id"
                :checked="item.featured === 1 ? true : false"
                :disabled="item.status === 'In Progress' ? false : true"
                @change="onChangeCheckBoxInput"
              />
            </td>
          </template>
          <template #isTestMode="{item}">
            <td class="featured-status">
              <CInputCheckbox
                class=""
                size="lg"
                custom
                :name="item.id"
                :id="item.id"
                :checked="item.isTestMode === 1 ? true : false"
                @change="onChangeTestCheckBoxInput"
              />
            </td>
          </template>
        </CDataTable>
      </CCardBody>
      <CCardFooter class="auction-manager-card__footer">
        <!-- <VAuctionManagerPagination
          class="auction-manager-card__footer-pagination"
          :current-page.sync="currentPage"
        /> -->
      </CCardFooter>
    </CCard>
    
  </div>
</template>

<script>
import {
  createMarketplaceMixin,
  marketplaceStore,
} from "@/mixins/marketplaceMixin";

export default {
  name: "VehicleImport",
  mixins: [createMarketplaceMixin()],

  data: () => {
    return {
      isSendingData: false,
      tableData: [],
      fields: [
        {
          key: "id",
          label: "ID",
          _classes: "username",
          _style: "min-width: 125px;max-width: 125px"
        },
        {
          key: "title",
          label: "Title",
          _style: "min-width: auto;max-width: 100px"
        },
        {
          key: "year",
          label: "Year",
          _classes: "auction-verified",
          _style: "min-width: 120px;max-width: 140px"
        },
        {
          key: "city",
          label: "City",
          _style: "min-width: 140px;max-width: 140px;text-align: center;"
        },
        {
          key: "state",
          label: "State"
        },
        {
          key: "address",
          label: "Address",
          _classes: "auction-kind",
          _style: "min-width: 125px;max-width: 125px;text-align: center;"
        },
        {
          key: "miles_formatted",
          label: "Miles",
          _classes: "auction-bid",
          _style: "min-width: auto;max-width: 70px;text-align: center;"
        },
        {
          key: "price",
          label: "Price",
          _style: "min-width: 62px;max-width: 62px"
        },
        {
          key: "ad_url",
          label: "Ad URL",
          _style: "min-width: 125px;max-width: 62px"
        },
        {
          key: "image",
          label: "Image",
          _style: "min-width: 125px;max-width: 62px"
        },
        {
          key: "seller_name",
          label: "Seller Name",
          _style: "min-width: 125px;max-width: 62px"
        },
        {
          key: "seller_url",
          label: "Seller URL",
          _style: "min-width: 125px;max-width: 62px"
        }
      ],
      loading: false
    };
  },
  methods: {
    async sendingData(){
      this.isSendingData = true;
      try{
        await this[marketplaceStore.actionTypes.ACTION_POST_DATA]({
        data: this.tableData
      })
        this.isSendingData = false
      }catch(err){
        this.isSendingData = false;
        console.log("error in sending data", err)
      }
    },
    fileInputFun(event) {
      const input = event.target;
      if (!input.files.length) {
        console.log("No file selected!");
        return;
      }

      const file = input.files[0];
      const reader = new FileReader();

      reader.onload = e => {
        const text = e.target.result;
        this.tableData = this.parseCSV(text);
        console.log("CSV Data:", this.tableData);
      };

      reader.onerror = function() {
        console.error("Error reading the file");
      };

      reader.readAsText(file);
      this.$refs.fileInput.value = null;
    },
    parseCSV(text) {
      const regex = /(?:^|,)(\"(?:[^\"]+|\"\")*\"|[^,]*)/g;
      const lines = text.split("\n");
      const headers = lines[0].split(",").map(header =>
        header
          .trim()
          .toLowerCase()
          .replace(/\s+/g, "_")
          .replace(/[()]/g, "")
      );
      return lines.slice(1).map(line => {
        const values = line.match(regex).map(
          field =>
            field
              .trim()
              .replace(/^,+/g, "")
        );
        return headers.reduce((obj, header, index) => {
          obj[header] = "https://www.facebook.com/marketplace/item/1056282848924339";
          console.log("obj",obj)
          return obj;
        }, {});
      });
    }
  }
};
</script>
<style>
.header-container {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
}
</style>
